
import Vue from 'vue'

const SET_LIST = (state, obj) => {
  state.list = obj.data
}

const SET_ONE = (state, obj) => {
  const { index, modulo } = obj
  if (index > -1) {
    Vue.set(state.list, index, modulo)
  } else {
    state.list.unshift(modulo)
  }
}

const REMOVE_ONE = (state, obj) => {
  state.list.splice(obj.index, 1)
}

export default {
  SET_LIST,
  SET_ONE,
  REMOVE_ONE
}



// WEBPACK FOOTER //
// ./src/features/admin/modulos/store/mutations.js